import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Dashboard from "./pages/Dashboard/Dashboard";
import GoalsListing from "./pages/Goals/GoalsListing";
import GoalsForm from "./pages/Goals/GoalsForm";
import MainLayout from "./pages/MainLayout";
import GoalsTable from "./pages/GoalsTable";
import Skillsform from "./pages/Skills/Skillsform";
import SkillsTable from "./components/Forms/SkillsTable";
import TeamCards from "./pages/TeamCards";
import Loginbg from "./pages/Login/Loginbg";
import Dummylayout from "./pages/Dummylayout";
import Myteamskills from "./pages/Skills/Myteamskills";
import SubGoal from "./components/Forms/SubGoal";
import SubGoalMain from "./pages/Goals/SubGoalMain";
import SubGoalTable from "./pages/SubGoalTable";
import CreateTemplateMain from "./pages/Apparaisal/CreateTemplateMain";
import GradeFormmain from "./pages/Apparaisal/GradeFormmain";
import CreateTemplateTab from "./components/CreateTamplateTab";
import PrimaryCategory from "./components/Forms/PrimaryCategory";
import PrimaryCategoryMain from "./pages/Apparaisal/PrimaryCategoryMain";
import ChooseTemplate from "./components/Forms/ChooseTemplate";
import ChooseTemplatemain from "./pages/Apparaisal/ChooseTemplatemain";
import SubCategorymain from "./pages/Apparaisal/SubCategorymain";
import SubCategoryTable from "./pages/Apparaisal/SubCategoryTable";
import SubCategoryData from "./pages/Apparaisal/SubCategoryData";
import AppealApprovalTable from "./pages/Apparaisal/AppealAprrovalTable";
import AppealMain from "./pages/Apparaisal/AppealMain";
import EditTemplatemain from "./pages/Apparaisal/EditTemplateMain";
import MyTeamAppraisal from "./pages/Apparaisal/MyTeamAppraisal";
import AppraisalTeamMember from "./pages/Apparaisal/AppraisalTeamMember";
import CreateTraining from "./pages/Idp/CreateTraining";
import ListTraining from "./pages/Idp/ListTraining";
import AssignTraining from "./pages/Idp/AssignTraining";
import ProfileDetails from "./components/ProfileDetails";
import Notifications from "./components/Notifications";
import MyPlanManager from "./pages/Idp/MyPlanManager";
import ViewMyAppraisal from "./pages/Apparaisal/ViewMyAppraisal";
import AssignAction from "./pages/Idp/AssignAction";
import MyTeamidp from "./pages/Idp/MyTeamPlanidp";

import ListPipTable from "./pages/pip/ListPipTable";
import InitiatePerformance from "./pages/pip/InitiatePerformance";
import CreateJobFamily from "./pages/competency/CreateJobFamily";
import ListJobFamAndRole from "./pages/competency/ListJobFamAndRole";
import AddComp from "./pages/competency/AddComp";
import AddCluster from "./pages/competency/AddCluster";
import AddJobFam from "./pages/competency/AddJobFam";
import AddJobRole from "./pages/competency/AddJobRole";
import ListClusterAndComp from "./pages/competency/ListClusterAndComp";
import MasterCluster from "./pages/competency/MasterCluster";
import MasterCompetency from "./pages/competency/MasterCompetency";
import MasterJobFamily from "./pages/competency/MasterJobFamily";
import MasterJobRole from "./pages/competency/MasterJobRole";
import MyTeamCompetency from "./pages/competency/MyTeamCompetency";
import CreateCluster from "./pages/competency/CreateCluster";
import InitiatePerformanceDirect from "./pages/pip/InitiatePerformanceDirect";
import MySkill from "./pages/Skills/MySkill";
import MySkillMain from "./pages/Skills/MySkillMain";
import ViewEmployeeAppraisal from "./pages/Apparaisal/ViewEmployessappraisal";
import ListAprraisal from "./pages/Apparaisal/ListAppraisalHR";

import ListAppraisalhrMain from "./pages/Apparaisal/LIstAprraisalhrMain";
import UserForm from "./components/User/UserForm";
import UserTableView from "./components/User/UserTableView";
import AwardMainForm from "./pages/Awards/AwardMainForm";
import AwardsListMain from "./pages/Awards/AwardsListMain";
import StarofYearMain from "./pages/Awards/StarYearMain";
import StarofListMain from "./pages/Awards/StarofYearListmain";
import TeamofQuarterMain from "./pages/Awards/TeamofQuarterMain";
import TeamofQuarterListMain from "./pages/Awards/TeamofQuarterListMain";
import MasterDesignationTableMain from "./pages/Master/MasterDesignationtableMain";
import LeaderQuarterListMain from "./pages/Awards/LeaderQuarterListMain";
import EmployeeofDepartmentListMain from "./pages/Awards/EmployeeofDepartmentListMain";
import { useState } from "react";
import InitiateAppraisalMain from "./pages/Apparaisal/InitiateAppraisalMain";
import AnnouncementFormMain from "./pages/AnnouncementPage/AnnouncementFormMain";
import AnnouncementTableMain from "./pages/AnnouncementPage/AnnouncementTableMain";
import SuperAdminPasswordMain from "./components/User/SuperAdminPasswordMain";
import ReportTableMain from "./pages/Apparaisal/ReportTableMain";




function App() {
  const [isSignedIn,setIsSignedIn]=useState(null)
  return (
    <div className="">
      <BrowserRouter>
        {
          /* <Routes>

          <Route index element={<Dashboard />} />
          <Route index path='/dashboard' element={<Dashboard />} />
          <Route path="/goals" element={<GoalsTable />} />
          <Route path="/goalsform" element={<GoalsForm />} />
          <Route Path="/Filter" element={<commonFilter/>}/>





        </Routes> */
          <Routes>
            <Route index element={<Loginbg />} />

            <Route path="/Dashboard" element={<Dashboard />} />
            <Route path="/goals" element={<GoalsTable />} />
            <Route path="/goalsform" element={<GoalsForm />} />
            <Route Path="/Filter" element={<commonFilter />} />

            <Route path="/Skills" element={<SkillsTable />} />
            <Route path="/Skillsforms" element={<Skillsform />} />
            <Route path="/myteamskill" element={<Myteamskills />} />
            <Route path="/subgoal" element={<SubGoalMain />} />
            <Route path="/subgoal" element={<SubGoalMain />} />
            <Route path="/subgoallist" element={<SubGoalTable />} />
            <Route path="/createtemplate" element={<CreateTemplateMain />} />
            <Route path="/gradeformmain" element={<GradeFormmain />} />
            <Route path="/createtemplatetab" element={<CreateTemplateMain />} />
            <Route
              path="/primarycategoryform"
              element={<PrimaryCategoryMain />}
            />
            <Route
              path="/choosetemplateform"
              element={<ChooseTemplatemain />}
            />
            <Route path="/subcategorymain" element={<SubCategorymain />} />
            <Route path="/subcategorytable" element={<SubCategoryData />} />
            <Route path="/appealapprovaltable" element={<AppealMain />} />
            <Route path="/edittemplate" element={<EditTemplatemain />} />
            <Route path="/myteamappraisal" element={<MyTeamAppraisal />} />
            <Route
              path="/appraisalteammember"
              element={<AppraisalTeamMember />}
            />
            <Route path="/createtrainingform" element={<CreateTraining />} />
            <Route path="/listelement" element={<ListTraining />} />
            <Route path="/assigntostaff" element={<AssignTraining />} />
            <Route path="/profile" element={<ProfileDetails />} />
            <Route path="/notifications" element={<Notifications />} />

            <Route path="/myplan" element={<MyPlanManager />} />
            <Route path="/myappraisal" element={<ViewMyAppraisal />} />
            <Route path="/viewemployessappraisal" element={<ViewEmployeeAppraisal />} />
            <Route path="/assigneeaction" element={<AssignAction />} />
            <Route path="/myteamplanidp" element={<MyTeamidp />} />
            <Route path="/initiatepip" element={<InitiatePerformance />} />
            <Route path="/piptable" element={<ListPipTable />} />

            <Route path="/CreateJobFam" element={<CreateJobFamily />} />
            <Route path="/ListJobFamRole" element={<ListJobFamAndRole />} />
            <Route path="/AddCompetencybut" element={<AddComp />} />
            <Route path="/AddClusterbut" element={<AddCluster />} />
            <Route path="/AddJobFambut" element={<AddJobFam />} />
            <Route path="/AddJobRolebut" element={<AddJobRole />} />
            <Route
              path="/ListClusterandComp"
              element={<ListClusterAndComp />}
            />
            <Route path="/mastercluster" element={<MasterCluster />} />
            <Route path="/mastercompetency" element={<MasterCompetency />} />
            {/* <Route path="/mastercluster" element={<MasterCluster/>} />
       <Route path="/mastercluster" element={<MasterCluster/>} /> */}
            <Route path="/masterjobfamily" element={<MasterJobFamily />} />
            <Route path="/masterjobrole" element={<MasterJobRole />} />
            <Route path="/myteamcomp" element={<MyTeamCompetency />} />
            <Route path="/comboclusandcomp" element={<CreateCluster />} />
            <Route path="/combojobfamandrole" element={<CreateJobFamily />} />
            <Route
              path="/initiatepipdirect"
              element={<InitiatePerformanceDirect />}
            />
            <Route path="/myskills" element={<MySkillMain />} />  
            <Route path="/listappraisal" element={<ListAppraisalhrMain/>} />
            <Route path="/listpastappraisal" element={<ListAppraisalhrMain/>} />
            <Route path="/userformspage" element={<UserForm/>} />
            <Route path="/userTable" element={<UserTableView/>} />
            <Route path="/awardsform" element={<AwardMainForm/>} />
            <Route path="/eomlist" element={<AwardsListMain/>} />
            <Route path="/startofyear" element={<StarofYearMain/>} />
            <Route path="/startofyearlist" element={<StarofListMain/>} />
            <Route path="/employeeofdept" element={<StarofYearMain/>} />
            <Route path="/employeeofdeptlist" element={<EmployeeofDepartmentListMain/>} />
            <Route path="/teamofquarter" element={<TeamofQuarterMain/>} />
            <Route path="/teamofquarterlist" element={<TeamofQuarterListMain/>} />
            <Route path="/leaderofquarter" element={<TeamofQuarterMain/>}
            />
            <Route path="/leaderofquarterlist" element={<LeaderQuarterListMain/>} />

            <Route path="/adddesignation" element={<MasterDesignationTableMain/>} />
            <Route path="/adddepartment" element={<MasterDesignationTableMain/>} />
            <Route path="/employeeofdepartment" element={<EmployeeofDepartmentListMain/>} />
            <Route path="/Initiateappraisal" element={<InitiateAppraisalMain/>} />
            <Route path="/Announcement" element={<AnnouncementFormMain/>} />
            <Route path="/AnnouncementList" element={<AnnouncementTableMain/>} />
            <Route path="/passwordchangeadmin" element={<SuperAdminPasswordMain/>} />
            <Route path="/reports" element={<ReportTableMain/>} />
            <Route path="/kpireports" element={<ReportTableMain/>} />
            <Route path="/kpioverall" element={<ReportTableMain/>} />
            <Route path="/reappraisal" element={<ReportTableMain/>} />
            <Route path="/pipdev" element={<ReportTableMain/>} />
            <Route path="/awardsreport" element={<ReportTableMain/>} />

          </Routes>
        }
      </BrowserRouter>
    </div>
  );
}

export default App;
